import { query, collection, getDocs } from 'firebase/firestore'
import _ from 'lodash'
import * as Sentry from '@sentry/react'

import { db } from 'controllers/db'
import store from 'model/store'
import { SupplierT, DictT } from 'shared/types/model'
import { receiveSuppliers } from 'model/actions'

export const fetchSuppliers = async () => {
  try {
    console.log('fetch suppliers')
    const q = query(collection(db, 'suppliers'))
    const sn = await getDocs(q)
    const res: DictT<SupplierT> = {}
    console.log('suppliers amount:', sn.size)
    sn.forEach(doc => {
      const p = doc.data()
      _.set(res, doc.id, p)
    })
    store.dispatch(receiveSuppliers(res))
  } catch (e) {
    Sentry.captureException(e)
    console.warn('fetchSuppliers error', e)
  }
}
